function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneySearch = function SvgMoneySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.019a6.46 6.46 0 0 1 .625-3.323A3 3 0 1 1 11.892 7.2 6.505 6.505 0 0 1 13.5 7c1.747 0 3.332.689 4.5 1.81V4Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5a4.5 4.5 0 1 1 8.31 2.396l2.397 2.397a.999.999 0 1 1-1.414 1.414l-2.397-2.397A4.5 4.5 0 0 1 9 13.5Zm4.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgMoneySearch;